import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppStateConstant } from 'app/shared/common/constants/AppState.constant';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { fuseAnimations } from '@fuse/animations';
import { LicenceModule } from 'app/shared/components/licence/licence.module';
import { LanguagePageModule } from 'app/shared/components/language-page/language-page.module';
import { TranslocoModule } from '@ngneat/transloco';
import { APP_CONFIG } from 'app.config';

@Component({
    selector: 'auth-callback',
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule,
        LicenceModule, LanguagePageModule, TranslocoModule
    ],
    template: '<!-- This component has no visual template -->',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class AuthCallbackComponent implements OnInit {

    currentYear: string = new Date().getFullYear().toString();
    appVersion: string = APP_CONFIG.VERSION;

    constructor(
        private oauthService: OAuthService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(success => {
            localStorage.removeItem(AppStateConstant.SIGNIN_AZURE_AD);
            if (success && this.oauthService.hasValidAccessToken()) {
                localStorage.setItem(AppStateConstant.SIGNIN_AZURE_AD, AppStateConstant.SIGNIN_ZITADEL);
            }
        }).finally(() => {
            this.router.navigateByUrl('/sign-in');
        });
    }
}
